// extracted by mini-css-extract-plugin
export default {"hero":"CmsFaqPage-hero-JsM","content":"CmsFaqPage-content-Ppt","sidebar":"CmsFaqPage-sidebar-lZT","sidebarTitle":"CmsFaqPage-sidebarTitle-L0z"};